<div id="fullscreen" class="btn-header transparent pull-right">
        <span> <a (click)="onToggle()" title="Full Screen"><i
                class="fa fa-arrows-alt"></i></a> </span>
</div>